var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"claio-schema-preview-root",on:{"dragstart":_vm.onDragStart}},[(_vm.imageSource)?_c('img',{class:{ 'claio-schema-preview-fit-size' : _vm.isFitted },attrs:{"src":_vm.imageSource}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }